export default __webpack_public_path__ + "static/media/Strangler's Boots of Arcane Death.8158c57d.jpg";